import entities from "./entities/index.js";
import contactInfo from "./contact-info";
import businessCustomerNewTransactionModal from "./business-customer-new-transaction-modal/business-customer-new-transaction-modal";
import environmentNotifier from "./environment-notifier/index.js";
import agencyPicker from "./agency-picker/agency-picker.js";
import changePasswordModal from "./change-password-modal/change-password-modal.js";
import choicesSelect from "./choices-select/choices-select";
import effectiveChoicesSelect from "./effective-choices-select/effective-choices-select.js";
import effectiveRangeActions from "./effective-range-actions/effective-range-actions.js";
import formAgencyPicker from "./form-selector/form-agency-picker/form-agency-picker.js";
import formSelector from "./form-selector/form-selector.js";
import formSelectorModal from "./form-selector/form-selector-modal/form-selector-modal.js";
import loadingTracker from "./loading-tracker/index.js";
import ieOverlay from "./ie-overlay/ie-overlay.js";
import markdownAsHtml from "./markdown-viewer/index.js";
import messageNotifications from "./message-notifications/message-notifications";
import messageNotification from "./message-notification/message-notification";
import messageListItem from "./message-list-item/message-list-item";
import messageBubble from "./message-bubble/message-bubble";
import reportingEntitySelector from "./reporting-entity-selector/reporting-entity-selector.js";
import reportScope from "./report-scope/report-scope.js";
import unsavedChanges from "./unsaved-changes/unsaved-changes.js";
import reportDetails from "./report-details/report-details.js";
import reportInvoices from "./report-invoices/report-invoices.js";
import createInvoiceModal from "./report-invoices/create-invoice-modal/create-invoice-modal.js";
import invoiceDetailsModal from "./modals/invoice-details-modal/invoice-details-modal.js";
import reportDetailsModal from "./report-details/report-details-modal/report-details-modal.js";
import reportActions from "./report-actions/report-actions.js";
import manageReport from "./manage-report/manage-report.js";
import inventoryActions from "./inventory-actions/inventory-actions.js";
import inventoryQuantityModal from "./inventory-actions/quantity-modal/quantity-modal.js";
import reportForm from "./report-form/report-form.js";
import reportStatus from "./report-status/index.js";
import exportStatus from "./export-status/index.js";
import pagination from "./pagination/index.js";
import userProfileModal from "./modals/user-profile-modal/user-profile-modal.js";
import userEntities from "./user/user-entities/user-entities.js";
import userForm from "./user/user-form/user-form.js";
import userModal from "./user/user-modal/user-modal.js";
import userRequests from "./user/user-requests/user-requests.js";
import userEntityAssociation from "./user/user-entities/user-entity-association/user-entity-association.js";
import rejectionReasonModal from "./user/user-requests/rejection-reason/rejection-reason.js";
import supportCenterContent from "./support-center-content/support-center-content.js";
import supportInfo from "./support-info/index.js";
import supportInfoModal from "./modals/support-info-modal/support-info-modal.js";
import tabbedModal from "./modals/tabbed-modal";
import viewModesSection from "./view-modes-section";
import noticeBanner from "./notices/banner/index.js";
import noticesModal from "./modals/notices-modal/notices-modal.js";
import tieredSelect from "./tiered-select/tiered-select.js";
import validationCallout from "./validation-callout/validation-callout.js";
import compliancePeriodMessage from "./compliance-period-message.js";
import helpers from "./field-helpers/selection-lookup.js";
import requireRole from "./require-role.js";
import dateRangeSelector from "./date-range-selector/date-range-selector.js";
import exportConfigurationSelector from "./export-configuration-selector/export-configuration-selector.js";
import dateTimePicker from "./date-time-picker/date-time-picker.js";
import actionInfoBlock from "./action-info-block";
import timezoneSelect from "./timezone-select";
import headerActions from "./header-actions/header-actions.js";

import terms from "./modals/terms-modal/index.js";
import accessibilityModal from "./modals/accessibility-modal/accessibility-modal.js";
import settingsModal from "./modals/settings-modal/settings-modal.js";
import supportFeedback from "./modals/support-feedback-modal/index.js";
import remoteSupport from "./modals/remote-support-modal/index.js";
import privacy from "./modals/privacy-policy-modal/index.js";
import deletion from "./modals/account-deletion-modal/index.js";
import primarySelector from "./modals/primary-selector-modal/primary-selector.js";
import buildInformationModal from "./modals/build-information-modal/index.js";
import cardSwipeModal from "./modals/card-swipe-modal/card-swipe-modal.js";
import formRequestModal from "./modals/form-request-modal";
import proxyModal from "./modals/proxy-modal/proxy-modal.js";
import negativeReportModal from "./modals/negative-report-modal/negative-report-modal.js";
import quickOpenModal from "./modals/quick-open-modal/quick-open-modal.js";
import * as exportInformationModals from "./modals/export-information-modal";
import exportActions from "./export-actions/export-actions";
import formAcceptanceModal from "./modals/agreement-display-modal";
import showAgreementsModal from "./modals/show-agreements-modal/index.js";
import invoiceList from "./invoice-list/invoice-list.js";
import markdownEditor from "./markdown-editor/markdown-editor.js";
import wideTableBanner from "./wide-table-banner/wide-table-banner.js";

const deps = [
	actionInfoBlock,
	timezoneSelect,
	headerActions,
	accessibilityModal,
	buildInformationModal,
	businessCustomerNewTransactionModal,
	agencyPicker,
	changePasswordModal,
	choicesSelect,
	effectiveChoicesSelect,
	compliancePeriodMessage,
	dateRangeSelector,
	dateTimePicker,
	contactInfo,
	entities,
	environmentNotifier,
	formAgencyPicker,
	formSelector,
	formSelectorModal,
	helpers,
	ieOverlay,
	loadingTracker,
	markdownAsHtml,
	markdownEditor,
	messageNotifications,
	messageNotification,
	messageListItem,
	messageBubble,
	pagination,
	primarySelector,
	privacy,
	remoteSupport,
	manageReport,
	reportActions,
	reportDetails,
	reportInvoices,
	createInvoiceModal,
	invoiceDetailsModal,
	reportDetailsModal,
	reportForm,
	reportingEntitySelector,
	reportScope,
	unsavedChanges,
	reportStatus,
	requireRole,
	supportFeedback,
	supportCenterContent,
	supportInfo,
	supportInfoModal,
	tabbedModal,
	viewModesSection,
	terms,
	tieredSelect,
	userProfileModal,
	userEntities,
	userForm,
	userModal,
	rejectionReasonModal,
	userRequests,
	userEntityAssociation,
	validationCallout,
	settingsModal,
	cardSwipeModal,
	formRequestModal,
	proxyModal,
	negativeReportModal,
	quickOpenModal,
	formAcceptanceModal,
	showAgreementsModal,
	noticesModal,
	noticeBanner,
	deletion,
	exportStatus,
	inventoryActions,
	inventoryQuantityModal,
	exportConfigurationSelector,
	effectiveRangeActions,
	invoiceList,
	exportActions,
	wideTableBanner,
	...Object.values(exportInformationModals)
];

export default angular.module("vesl.components", deps).name;
